/**
 * Cómo se lee el folio de una orden de trabajo.
 *
 * El «OT-» es presentación: no se guarda. Las órdenes que ya existen no lo
 * traen, y guardarlo obligaría a convertirlas todas y a que los archivos
 * del cliente lo incluyeran. Al buscar, la API lo quita —con guion o sin
 * él—, así que da igual escribir OT-12345, OT12345 o 12345.
 *
 * Los ceros de la izquierda sí son parte del folio: 0012345 y 12345 son
 * órdenes distintas para quien las emitió, y por eso el campo es texto y
 * nunca pasa por un número.
 */
export function folioOT(folio: string | null | undefined): string {
  const limpio = (folio ?? '').trim();
  if (limpio === '') return '—';

  const yaLoTrae = /^ot[-\s]?/i.exec(limpio);
  if (yaLoTrae) return `OT-${limpio.slice(yaLoTrae[0].length).toUpperCase()}`;

  return `OT-${limpio.toUpperCase()}`;
}
